<template>
  <div class="container">
    <img class="bg_img" :src="`${$cdn}/assets/images/bg/${isMobile?'mobile_':''}bg.jpg`" alt="">
    <div class="home_btn" @click="tiaoguo">
      <p>进<span></span>入</p>
    </div>
  </div>
</template>

<script>
import browser from '@/utils/browser'

export default {
  name: 'Home',
  data(){
    return{
      current:0,
      isMobile: browser.mobile
    }
  },
  components: {
    
  },
  methods:{
    tiaoguo(){
      this.$emit('audio',true)
      this.$router.push({path:'list'})
    }
  },
  mounted(){
  }
}
</script>

<style lang="less" scoped>
.container{
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  .bg_img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    transition: all ease .5s;
    z-index: -1;
  }
  
  .logo{
    position: absolute;
    left: 60px;
    top: 30px;
    z-index: 99999;
    width: 300px;
  }
  .logo2{
    left: unset;
    top: 30px;
    right: 30px;
    width: 200px;
  }
  .home_btn{
    position: absolute;
    left: 59%;
    bottom: 30%;
    z-index: 9999;
    font-size: 0;
    cursor: pointer;
    color: #fff;
    p{
      color: #fff;
      margin-bottom: 4px;
      font-size: 24px;
      padding:  10px 20px;
      text-shadow: 0 5px 10px rgba(0, 0, 0, 1);
      text-align: center;
      background: linear-gradient(to bottom,#e8c668,rgba(#e8c668,0.1));
      border-radius: 8px;
      >span{
        padding: 0 15px;
      }
    }
   
  }
 
}

@media screen and (max-width: 500px) {
  .container{
    max-width: 500px;
     .bg_img{
        height: 100%;
        width: auto;
      }
    .logo{
      width: 40%;
      left: 20px;
      top: 30px;
    }
    .logo2{
      right: 10px;
      left: unset;
      width: 38%;
    }
    .home_btn{
      transform: translateX(-50%);
      bottom: 14%;
      left: 50%;
      p{
        font-size: 16px;
        >span{
          padding: 0 5px;
        }
      }
    
    }
    
  }
}
</style>